import { Debounce, Module, Second } from '@nu-art/ts-common';
import { dispatch_OnExpressionCalculationResult, dispatch_OnProtocolNavigationSimulationResult } from './dispatchers.js';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
class ModuleFE_ExplainV2_Class extends Module {
    debounce_ExpressionResult = new Debounce((request, onError) => this.simulate_ExpressionResult_Impl(request, onError), 1.5 * Second, 5 * Second);
    debounce_ProtocolNavigation = new Debounce((request, onError) => this.simulate_ProtocolNavigation_Impl(request, onError), 1.5 * Second, 5 * Second);
    //######################### Internal Logic #########################
    simulate_ExpressionResult_Impl = async (request, onError) => {
        try {
            const response = await ModuleFE_EMInterface.vv1.calculator.simulateExpressionCalculation(request).executeSync();
            dispatch_OnExpressionCalculationResult.dispatchAll(response);
            return response;
        }
        catch (err) {
            this.logError('Expression calculation failed', err);
            onError?.();
        }
    };
    simulate_ProtocolNavigation_Impl = async (request, onError) => {
        try {
            const response = await ModuleFE_EMInterface.vv1.navigator.simulateNavigation(request).executeSync();
            dispatch_OnProtocolNavigationSimulationResult.dispatchAll(response);
            return response;
        }
        catch (err) {
            this.logError('Protocol navigation simulation failed', err);
            onError?.();
        }
    };
    simulate_ExpressionResult(expressionIds, emFindings, immediate, onError) {
        this.debounce_ExpressionResult.trigger({ expressionIds, ...emFindings }, onError);
        if (immediate)
            return this.debounce_ExpressionResult.flush();
    }
    simulate_ProtocolNavigation(pathwayId, expressionIds, emFindings, immediate, onError) {
        this.debounce_ProtocolNavigation.trigger({ pathwayId, expressionIds, ...emFindings }, onError);
        if (immediate)
            return this.debounce_ProtocolNavigation.flush();
    }
    clearSimulations = () => {
        this.debounce_ExpressionResult.clear();
        this.debounce_ProtocolNavigation.clear();
    };
}
export const ModuleFE_ExplainV2 = new ModuleFE_ExplainV2_Class();
//# sourceMappingURL=ModuleFE_ExplainV2.js.map